import { render, staticRenderFns } from "./recommend_crossevent.vue?vue&type=template&id=d4b19be4"
import script from "./recommend_crossevent.vue?vue&type=script&lang=js"
export * from "./recommend_crossevent.vue?vue&type=script&lang=js"
import style0 from "./recommend_crossevent.vue?vue&type=style&index=0&id=d4b19be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports